/* eslint-disable no-underscore-dangle */
import BaseService from './BaseService';

class SystemService extends BaseService {
  getSettings(list = []) {
    const params = Array.isArray(list) && list.length > 0 ? list.join(',') : '';
    return this.get(`/system/settings/${params}`);
  }
}

export default SystemService;
